import { Link, type ErrorComponentProps } from '@tanstack/react-router';
import { Button, EmptyState, ErrorState } from '@buildbee/ui';

export function RootErrorPage({ error, reset }: ErrorComponentProps) {
  return (
    <div className="mx-auto max-w-xl p-8">
      <ErrorState error={error} onRetry={reset} />
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-xl p-8">
      <EmptyState
        title="Page not found"
        description="The page you are looking for does not exist or was moved."
        action={
          <Button asChild variant="outline">
            <Link to="/">Go home</Link>
          </Button>
        }
      />
    </div>
  );
}

/** Placeholder rendered by module routes that are not built yet. */
export function ModulePlaceholder({ title, description }: { title: string; description: string }) {
  return (
    <div className="space-y-6">
      <h1 className="text-[28px] font-semibold leading-tight tracking-[-0.025em] sm:text-[32px]">{title}</h1>
      <EmptyState title={`${title} is on its way`} description={description} />
    </div>
  );
}
